export default {
  'content-flow.none': 'Geen STEAMS schema beschikbaar voor deze les',
  'content-flow.loading': 'Laden...',
  'content-flow.no.slides': 'Er zijn geen slides voor deze les',
};
